/* eslint-disable array-callback-return */
import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { Helmet } from "react-helmet";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box, Button, Chip, Grid, Grow, InputAdornment, Paper, TextField, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import Header from "components/Header/Header";
import PaymentBreakDown from "components/Screens/Customers/CustomerDetials/PaymentBreakDown";
import PageLoader from "components/common/PageLoader";
import Filter from "components/Widgets/Filter";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import totalEmployeesIcon from "components/Icons/TotalEmployeesIcon.png";

import { baseUrl } from "util/APIBaseUrl";
import getRequest from "util/APIHelperGet";
import downloadFile from "util/downloadHelper";
import { AlertType } from "components/common/Snackbar";

import { GetEmployeeSalaries } from "store/actions/EmployeeSalaries";
import { GetEmployeeDetails } from "store/actions/GetEmployeeDetails";
import { GetCustomersList, ResetGetCustomersList } from "store/actions/Customers/GetCustomerList";
import { ResetemployeeSalaryInfo } from "store/actions/Workforce/EmployeeDetils/SalaryInfo";
import { ResetAddEmployeeSalaryData } from "store/actions/Workforce/AddEmployee/AddEmployeeSalaryData";
import { ResetAddEmployeeSalary } from "store/actions/Workforce/AddEmployee/AddEmployeeSalary";
import { ResetCalculateEmployeeSalary } from "store/actions/Workforce/AddEmployee/CalculateEmployeeSalary";
import { showSnackbar } from "store/actions/Utility";

let filterRemoved = false;

const styles = {
  position: "absolute",
  width: 300,
  top: 35,
  right: 0,
  left: -275,
  zIndex: 1,
  border: "1px light gray",
  p: 3,
  bgcolor: "background.paper",
};

let newDate = new Date(new Date().setDate("01"));
let dateFlag;

function Salaries() {
  const dispatch = useDispatch();
  const openFilterMenu = useRef(null);
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [DropdownData_, setDropdownData_] = useState({});
  const [selectedOptions, setSelectedOptions] = useState({});
  const [apiFilters, setApiFilters] = useState({});
  const [sortBy, setSortBy] = useState({});
  const [resetPage, setResetPage] = useState(false);
  const [searchEmployee, setSearchEmployee] = useState("");
  const [navigateToPage, setNavigateToPage] = useState(null);
  const [selectedRowID, setSelectedRowID] = useState(null);
  const [timer, setTimer] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(moment(new Date().setDate(1)).format("YYYY-MM-DD"));

  const getEmployeeDetails = useSelector((state) => state.GetEmployeeDetails.getEmployeeDetails);
  const loadingGetEmployeeDetails = useSelector((state) => state.GetEmployeeDetails.loadingGET_EMPLOYEE_Details);
  const userAdditionalInfo = useSelector((state) => state.UserAdditionalInfo.userAdditionalInfo);
  const loadingAdditionalInfo = useSelector((state) => state.UserAdditionalInfo.loadingAdditionalInfo);
  const getCustomerList = useSelector((state) => state.GetCustomerList.getCustomerList);
  const loadingGetCustomerList = useSelector((state) => state.GetCustomerList.loadingGetCustomerList);
  const employeeSalaries = useSelector((state) => state.EmployeeSalaries.employeeSalaries);
  const loadingEmployeeSalaries = useSelector((state) => state.EmployeeSalaries.loadingEmployeeSalaries);
  const loadingGetNoticeBoard = useSelector((state) => state.GetNoticeBoard.loadingGetNoticeBoard);

  const rotate = open ? "rotate(180deg)" : "rotate(0)";

  const closeOpenMenus = (e) => {
    if (openFilterMenu.current && open && !openFilterMenu.current.contains(e.target)) {
      setOpen(false);
    }
  };
  document.addEventListener("mousedown", closeOpenMenus);

  const handleClick = () => {
    setOpen(!open);
  };

  const handleReset = () => {
    setOpen(false);
    setResetPage(true);
    setPage(0);
    setSearchEmployee("");
    setApiFilters({});
    setSelectedOptions({ countries: [], customers: [] });
    filterRemoved = true;
  };

  const handlePagination = (pagination) => {
    setRowsPerPage(pagination.rowsPerPage);
    setPage(pagination.page);
  };

  const handleSelectedRow = (selectedEmployeeID, navigateTo) => {
    let loggedInUser = {};
    loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));
    dispatch(ResetAddEmployeeSalaryData({}));
    dispatch(ResetAddEmployeeSalary({}));
    dispatch(ResetCalculateEmployeeSalary({}));
    if (
      Object.keys(loggedInUser).length &&
      loggedInUser.userId != undefined &&
      selectedEmployeeID != null &&
      selectedEmployeeID != undefined
    ) {
      dispatch(
        GetEmployeeDetails({
          customerID: loggedInUser?.userId,
          employeeID: selectedEmployeeID,
          request: `employee/${selectedEmployeeID}`,
        })
      );
      setSelectedRowID(selectedEmployeeID);
      setNavigateToPage(navigateTo);
    }
  };

  const handleSearchEmployee = (event) => {
    setSearchEmployee(event.target.value);
    setResetPage(true);
    setApiFilters({
      ...apiFilters,
      name: event.target.value,
    });
    setPage(0);
  };

  const handleDelete = (event, key, option) => {
    event.preventDefault();
    setOpen(false);
    if (selectedOptions[key]) {
      const newdict = { ...selectedOptions };
      newdict[key] = selectedOptions[key].filter((selectedOption) => selectedOption !== option);
      filterRemoved = true;

      if (!newdict[key].length && key == "customers") {
        dispatch(ResetemployeeSalaryInfo({}));
      }
      setSelectedOptions(newdict);
    }
  };

  const callbackFromMultiSelect = (option, key) => {
    selectedOptions[key] = option;
    setResetPage(true);
    setSelectedOptions({
      ...selectedOptions,
    });
  };

  const handleRequestSortBy = (request) => {
    setSortBy(request);
  };

  const handleExport = async () => {
    setLoading(true);
    const response = await getRequest(
      `${baseUrl}/employeePayrolls?${new URLSearchParams({
        limit: rowsPerPage,
        export: true,
        page,
        date: selectedDate,
        orderBy: JSON.stringify({
          field: sortBy?.field,
          direction: sortBy?.direction,
        }),
        filter: JSON.stringify({
          employeeName: [searchEmployee || ""],
          country: apiFilters?.countries,
          First_Name: apiFilters?.employeeName,
          companyName: apiFilters?.customers,
        }),
      })}`,
      true,
      "export"
    );
    setLoading(false);

    if (!response?.ok) {
      return;
    }

    downloadFile(response?.payload, "WorkForce Payrolls");
  };

  const handlePayoneer = async () => {
    setLoading(true);
    const response = await getRequest(
      `${baseUrl}/payoneer/mass-payout-export?${new URLSearchParams({
        date: selectedDate,
        orderBy: JSON.stringify({
          field: sortBy?.field,
          direction: sortBy?.direction,
        }),
        filter: JSON.stringify({
          employeeName: [searchEmployee],
          country: apiFilters?.countries,
          First_Name: apiFilters?.employeeName,
          companyName: apiFilters?.customers,
        }),
      })}`,
      true,
      "export"
    );
    setLoading(false);

    if (!response?.ok) {
      return;
    }

    downloadFile(response?.payload, "Payoneer Mass Payout");
  };

  const handleOneTimeChargesExport = async () => {
    setLoading(true);
    const response = await getRequest(
      `${baseUrl}/customers/oneTimeCharges?${new URLSearchParams({ date: selectedDate })}`,
      true,
      "export"
    );
    setLoading(false);

    if (!response?.ok) {
      return;
    }

    if (response?.payload?.size === 0) {
      dispatch(showSnackbar({ type: AlertType.info, message: "No one-time charges found", dispatch }));
      return;
    }

    downloadFile(response?.payload, "One-Time Charges");
  };

  const callbackFromDatePicker = (newValue) => {
    newDate = newValue;
    dateFlag = true;
  };

  const onCloseDatePicker = () => {
    if (dateFlag) {
      const formattedDate = moment(newDate).format("YYYY-MM-DD");
      setSelectedDate(formattedDate);
      setResetPage(true);
    }
  };

  const searchCustomer = (customerName) => {
    clearTimeout(timer);
    const newTimer = setTimeout(() => {
      if (customerName.length >= 3) {
        dispatch(
          GetCustomersList({
            customerName,
            loaderFlag: false,
          })
        );
      } else {
        dispatch(ResetGetCustomersList({}));
      }
    }, 500);

    setTimer(newTimer);
  };

  useEffect(() => {
    if (getEmployeeDetails.ok) {
      if (navigateToPage) {
        if (selectedRowID && navigateToPage == "details") {
          navigate(`/main/details/${selectedRowID}`);
        } else if (navigateToPage == "addEmployee") {
          navigate("/main/addEmployee", {
            state: {
              navigatedFor: "editEmployee",
              redirectTo: "workforce",
              editEmployeeId: selectedRowID,
            },
          });
        }
      }
    }
  }, [getEmployeeDetails]);

  useEffect(() => {
    let apiFilter = {};
    let arr = [];

    if (selectedOptions && Object.keys(selectedOptions).length) {
      arr = [];
      Object.keys(selectedOptions).map((header) => {
        selectedOptions[header].map((option) => {
          arr.push(option.key);
        });

        apiFilter[header] = arr;
        arr = [];
      });
      setApiFilters(apiFilter);

      dispatch(
        GetEmployeeSalaries({
          request: `${baseUrl}/employeePayrolls`,
          rowsPerPage,
          page: 0,
          searchEmployee,
          date: selectedDate,
          dist: apiFilter,
          sortBy: {
            field: sortBy.orderBy,
            direction: sortBy.order,
          },
        })
      );
      apiFilter = [];
      // eslint-disable-next-line no-dupe-else-if
    } else if (selectedOptions && Object.keys(selectedOptions).length && filterRemoved) {
      dispatch(
        GetEmployeeSalaries({
          request: `${baseUrl}/employeePayrolls`,
          rowsPerPage,
          page,
          searchEmployee,
          date: selectedDate,
          dist: null,
          sortBy: {
            field: sortBy.orderBy,
            direction: sortBy.order,
          },
        })
      );
    }
  }, [selectedOptions]);

  useEffect(() => {
    const customers = [];

    if (getCustomerList?.ok) {
      getCustomerList?.payload?.map((data) => {
        customers.push({
          key: data.companyName,
          value: data.companyName,
        });
      });
    }
    setDropdownData_({
      ...DropdownData_,
      customers,
    });
  }, [getCustomerList]);

  useEffect(() => {
    const triggerCall = setTimeout(() => {
      if (sortBy?.orderBy && sortBy?.order) {
        dispatch(
          GetEmployeeSalaries({
            request: `${baseUrl}/employeePayrolls`,
            rowsPerPage,
            page,
            searchEmployee,
            date: selectedDate,
            dist: apiFilters,
            sortBy: {
              field: sortBy.orderBy,
              direction: sortBy.order,
            },
          })
        );
      } else {
        dispatch(
          GetEmployeeSalaries({
            request: `${baseUrl}/employeePayrolls`,
            rowsPerPage,
            searchEmployee,
            date: selectedDate,
            page,
            dist: apiFilters,
            sortBy: null,
          })
        );
      }
    }, 500);

    return () => clearTimeout(triggerCall);
  }, [rowsPerPage, page, sortBy, searchEmployee, selectedDate]);

  useEffect(() => {
    const countries = [];
    const customers = [];
    let dropdownData = {};

    dropdownData = JSON.parse(sessionStorage.getItem("dropdownData"));

    if (dropdownData && Object.keys(dropdownData).length && dropdownData.ok) {
      dropdownData?.payload?.country?.map((data) => {
        countries.push({
          key: data.countryCode,
          value: data.countryCode,
        });
      });
    }
    setDropdownData_({
      ...DropdownData_,
      countries,
      customers,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Edge | Finances</title>
      </Helmet>
      {loadingAdditionalInfo ||
      loadingEmployeeSalaries ||
      loading ||
      loadingGetEmployeeDetails ||
      loadingGetCustomerList ||
      loadingGetNoticeBoard ? (
        <PageLoader />
      ) : null}
      <Grid container direction="column" rowSpacing={3}>
        <Grid item>
          <Header
            data={{
              heading: "Finances",
              profileWithIcon: null,
            }}
          />
        </Grid>
        <Grid item>
          <PaymentBreakDown
            selectedOptions={apiFilters}
            selectedFiltersList={
              <Grid
                item
                container
                direction="row"
                justifyContent="flex-end"
                columnSpacing={3}
                style={{
                  left: "-80px",
                }}
              >
                <Grid item>
                  {Object.keys(selectedOptions).map((key) => {
                    return selectedOptions[key].map((option) => {
                      return (
                        <Chip
                          key={option.key}
                          label={<Typography variant="h6">{option.value}</Typography>}
                          clickable
                          sx={{
                            bgcolor: "#D3E0F4",
                            mx: 0.5,
                            height: 26,
                            borderRadius: "10px",
                            color: "#1161D5",
                            "& .MuiChip-deleteIcon": {
                              color: "#3C7DDC",
                              fontSize: "1.0rem",
                            },
                          }}
                          onDelete={(e) => handleDelete(e, key, option)}
                        />
                      );
                    });
                  })}
                </Grid>
              </Grid>
            }
            paymentDetail={userAdditionalInfo}
            resetPage={resetPage}
            customerPayment={employeeSalaries}
            openDetailsPage="employeeName"
            salariesPage
            toolBar
            title={`Payroll Records (${employeeSalaries?.count ? employeeSalaries.count : 0})`}
            titleIcon={totalEmployeesIcon}
            filterButton={
              <Box sx={{ position: "relative" }} ref={openFilterMenu}>
                <FilterListIcon
                  onClick={handleClick}
                  style={{
                    transform: rotate,
                    transition: "all 0.2s linear",
                  }}
                />
                <Grow
                  in={open}
                  style={{
                    transformOrigin: "right 0 0 ",
                  }}
                  {...(open ? { timeout: 350 } : {})}
                  unmountOnExit
                >
                  <Paper elevation={3} sx={styles}>
                    <Filter
                      searchCustomer={searchCustomer}
                      data={DropdownData_}
                      selectedOptions={selectedOptions}
                      handleReset={handleReset}
                      callbackFromMultiSelect={callbackFromMultiSelect}
                    />
                  </Paper>
                </Grow>
              </Box>
            }
            datePicker={
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  views={["month", "year"]}
                  value={selectedDate}
                  onClose={onCloseDatePicker}
                  onChange={(newValue) => {
                    callbackFromDatePicker(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        "&.MuiTextField-root": {
                          marginTop: 0,
                        },
                        "& .MuiInputBase-root": {
                          backgroundColor: "white",
                          borderRadius: "5px",
                          fontFamily: "Poppins-Medium !important",
                          height: "38px",
                        },

                        "& .MuiSvgIcon-root": {
                          fill: "#1161D5",
                        },
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            }
            SearchEmployee={
              <TextField
                sx={{
                  "&.MuiTextField-root": {
                    marginTop: 0,
                  },
                  "& .MuiInputBase-root": {
                    backgroundColor: "white",
                    borderRadius: "5px",
                    fontFamily: "Poppins-Medium !important",
                    height: "38px",
                  },
                }}
                id="userName"
                variant="outlined"
                placeholder="Enter Employee Name"
                size="small"
                name="email"
                value={searchEmployee}
                fullWidth
                onChange={handleSearchEmployee}
                margin="normal"
                InputProps={{
                  disableUnderline: true,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon
                        sx={{
                          mx: 1,
                        }}
                      />
                    </InputAdornment>
                  ),
                }}
              />
            }
            handleSelectedRow={handleSelectedRow}
            handlePagination={handlePagination}
            handleRequestSortBy={handleRequestSortBy}
            ExportButton={
              <>
                <Button
                  disableElevation
                  variant="contained"
                  fullWidth
                  sx={{
                    width: "170px",
                    height: "35px",
                    borderRadius: "5px",
                    color: "white",
                    marginRight: "5px",
                  }}
                  onClick={handlePayoneer}
                >
                  <Typography variant="h6" color="white">
                    Export Payment File
                  </Typography>
                </Button>
                <Button
                  disableElevation
                  variant="contained"
                  fullWidth
                  sx={{
                    width: "115px",
                    height: "35px",
                    borderRadius: "5px",
                    color: "white",
                  }}
                  onClick={handleExport}
                >
                  <Typography variant="h6" color="white">
                    Export Payroll
                  </Typography>
                </Button>
                <Button
                  disableElevation
                  variant="contained"
                  fullWidth
                  sx={{
                    width: "189px",
                    height: "35px",
                    borderRadius: "5px",
                    color: "white",
                    marginLeft: "5px",
                  }}
                  onClick={handleOneTimeChargesExport}
                >
                  <Typography variant="h6" color="white">
                    Export One-Time Charges
                  </Typography>
                </Button>
              </>
            }
          />
        </Grid>
      </Grid>
    </>
  );
}

export default Salaries;
